<template>
  <div class="pa-10">
    <MoaAndAgreementDataTable />
  </div>
</template>

<script>
import MoaAndAgreementDataTable from "@/components/Utils/MoaAndAgreementDataTable.vue";

export default {
  components: {
    MoaAndAgreementDataTable,
  },
  created() {
    if (this.$store.state.expiryDate < Date.now()) {
      this.$store.dispatch("setUser", null);
      this.$store.dispatch("setIsAuthenticated", 0);
      this.render = true;
      this.$router.push("/");
    }
  },
  data: () => ({
    typeData: [],
    action: null,
    reload: false,
  }),
  methods: {},
};
</script>

<style></style>
